<div
    [ngClass]="{ 'view-mode-only': data.viewModeOnly }"
    fxFlex="0 0 100%"
    fxLayout="column"
    fxLayoutAlign="start center"
>
    <app-sticky-header
        class="sticky-header"
        title="Material block"
        context="Layout"
        i18n-context="@@layout"
        contextIcon="vertical_split"
        (onSubmit)="onSubmit()"
        (onCancel)="onCancel()"
        savingTitle="Save"
        i18n-savingTitle="@@save"
        [savingStatus]="false"
    ></app-sticky-header>
    <div class="info">
        <span class="spacer"></span>
        <span i18n>Drag and drop to rearrange items in the layout</span>
        <button
            mat-icon-button
            (click)="displayLayout = !displayLayout"
            i18n-matTooltip="@@display-layout"
            matTooltip="Display layout"
        >
            <mat-icon>{{ displayLayout ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
    </div>

    <div *ngIf="!displayLayout" class="items-wrapper">
        <div class="item-wrap left">
            <span class="title" i18n>Main column (66.6%)</span>
            <div
                cdkDropList
                #leftSideItemsList="cdkDropList"
                [cdkDropListData]="leftSideItemsDisplay"
                [cdkDropListConnectedTo]="[rightSideItemsList]"
                class="list"
                (cdkDropListDropped)="drop($event)"
            >
                <div *ngFor="let item of leftSideItemsDisplay" class="box" cdkDrag>
                    <mat-icon>{{ item.mediaData.icon }}</mat-icon>
                    <span>{{ item.title }}</span>
                    <mat-icon class="drag-handle">drag_indicator</mat-icon>
                    <div *cdkDragPreview class="box-preview-material-parent">
                        <mat-icon>{{ item.mediaData.icon }}</mat-icon>
                        <span>{{ item.title }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="item-wrap right">
            <span class="title" i18n>Side column (33.3%)</span>
            <div
                cdkDropList
                #rightSideItemsList="cdkDropList"
                [cdkDropListData]="rightSideItemsDisplay"
                [cdkDropListConnectedTo]="[leftSideItemsList]"
                class="list"
                (cdkDropListDropped)="drop($event)"
            >
                <div *ngFor="let item of rightSideItemsDisplay" class="box" cdkDrag>
                    <mat-icon class="icon">{{ item.mediaData.icon }}</mat-icon>
                    <span>{{ item.title }}</span>
                    <mat-icon class="drag-handle">drag_indicator</mat-icon>
                    <div *cdkDragPreview class="box-preview-material-parent">
                        <mat-icon class="icon">{{ item.mediaData.icon }}</mat-icon>
                        <span>{{ item.title }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="display-wrapper" *ngIf="displayLayout" fxLayout="row" fxLayoutAlign="center start">
        <div
            *ngIf="!!leftSideItemsDisplay.length && !!rightSideItemsDisplay.length"
            class="two-column-display"
            fxLayout="row"
            fxLayoutAlign="start start"
        >
            <div class="left-column" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
                <ng-container *ngFor="let item of leftSideItemsDisplay">
                    <ng-container *ngTemplateOutlet="mediaView; context: { item: item }"></ng-container>
                </ng-container>
            </div>
            <div class="right-column" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
                <ng-container *ngFor="let item of rightSideItemsDisplay">
                    <ng-container *ngTemplateOutlet="mediaView; context: { item: item }"></ng-container>
                </ng-container>
            </div>
        </div>
        <div
            *ngIf="!(!!leftSideItemsDisplay.length && !!rightSideItemsDisplay.length)"
            class="two-column-display"
            fxLayout="row"
            fxLayoutAlign="start start"
        >
            <div
                *ngIf="!!leftSideItemsDisplay.length"
                fxLayout="column"
                fxLayoutAlign="center start"
                fxLayoutGap="10px"
            >
                <ng-container *ngFor="let item of leftSideItemsDisplay">
                    <ng-container *ngTemplateOutlet="mediaView; context: { item: item }"></ng-container>
                </ng-container>
            </div>
            <div
                *ngIf="!!rightSideItemsDisplay.length"
                fxLayout="column"
                fxLayoutAlign="center start"
                fxLayoutGap="10px"
            >
                <ng-container *ngFor="let item of rightSideItemsDisplay">
                    <ng-container *ngTemplateOutlet="mediaView; context: { item: item }"></ng-container>
                </ng-container>
            </div>
        </div>
    </div>
</div>
<ng-template #mediaView let-item="item">
    <div class="media-wrapper" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
        <div class="media-title">
            {{ item.title }}
        </div>
        <app-player-media-view
            class="media"
            [resourceItemTypeValue]="item.item_type_value"
            [media_id]="item.name"
            [canDownlaodMedia]="item.can_download"
            [displayName]="false"
            [ngClass]="{ 'text-material': item.item_type_value == 'text_material' }"
        >
        </app-player-media-view>
    </div>
</ng-template>
